import * as THREE from 'three';

export class FikoVektor3D extends THREE.Vector3 {

    constructor(x?: number, y?: number, z?: number) {
        super(x, y, z);
    }
}